import { Controller } from "stimulus";
import csrfPrefilter from "../components/csrf_prefilter";
import $ from 'jquery'
import Cropper from 'cropperjs';

export default class ImageUploadController extends Controller {
  static targets = [
    'configuredImage',
    'trimingImage',
    'imageFileForm',
    'cropperForm'
  ];

  selectFile(e) {
    this.imageFileFormTarget.classList.add('hidden');
    this.configuredImageTarget.classList.add('hidden');
    const src = (window.URL ? URL : webkitURL).createObjectURL(e.target.files[0]);
    this.trimingImageTarget.src = src;
    this.trimingImageTarget.style.height = '15rem';
    this.cropperFormTarget.classList.remove('hidden');

    this.cropper = new Cropper(this.trimingImageTarget, {
      aspectRatio: 1,
      dragMode: 'none'
    });
  }

  submit(e) {
    e.preventDefault();
    this.cropper.getCroppedCanvas().toBlob((blob) => {
      const formData = new FormData(this.imageFileFormTarget);
      const fileOfBlob = new File(
        [blob],
        formData.get('primary_image_form[_image]').name
      )
      formData.append('primary_image_form[primary_image]', fileOfBlob)
      formData.delete('primary_image_form[_image]')
      csrfPrefilter();
      $.ajax('/profiles/primary_image', {
        method: 'PATCH',
        data: formData,
        processData: false,
        contentType: false,
        success() {
          location.reload();
        },
        error() {
          location.reload();
        },
      });
    })
  }
}
